import type { CSSObjectWithLabel, StylesConfig } from 'react-select';

/**
 * Menu layering for task modals (portal above modal chrome).
 * Control/value styling stays on {@link SelectorStyles} defaults — same shell as Task assignee.
 */
export function tasksSelectOverlayStyles<Option>(): Pick<
  StylesConfig<Option, false>,
  'menu' | 'menuPortal'
> {
  return {
    menu: (base: CSSObjectWithLabel) => ({
      ...base,
      boxShadow: '0px 4px 14px 0px rgba(0, 0, 0, 0.12)',
      border: 'none',
      borderRadius: '6px',
      minWidth: '100%',
      zIndex: 9999,
    }),
    menuPortal: (base: CSSObjectWithLabel) => ({
      ...base,
      zIndex: 9999,
    }),
  };
}
